import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M12 2q2 2.5 0 5t0 5 0 5 0 5', key: '13jdbg' }],
  ['path', { d: 'M19 2q2 2.5 0 5t0 5 0 5 0 5', key: '1ozhzu' }],
  ['path', { d: 'M5 2q2 2.5 0 5t0 5 0 5 0 5', key: '1bi6v5' }],
];

/**
 * @component @name WavesVertical
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMnEyIDIuNSAwIDV0MCA1IDAgNSAwIDUiIC8+CiAgPHBhdGggZD0iTTE5IDJxMiAyLjUgMCA1dDAgNSAwIDUgMCA1IiAvPgogIDxwYXRoIGQ9Ik01IDJxMiAyLjUgMCA1dDAgNSAwIDUgMCA1IiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/waves-vertical
 * @see https://lucide.dev/guide/packages/lucide-vue-next - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {FunctionalComponent} Vue component
 *
 */
const WavesVertical = createLucideIcon('waves-vertical', __iconNode);

export default WavesVertical;
